// The @pa/ui time helpers this feature uses, plus a short month name for a local date.
import { fmtShortDate } from '@pa/ui'

export { fmtDayOf, fmtTime, todayIn, zonedParts } from '@pa/ui'

/** "Oct" for "2026-10-07". */
export const MONTHS_SHORT_OF = (date: string): string => fmtShortDate(date).split(' ')[0] ?? ''
